import React from 'react';
import classNames from 'classnames/bind';

// Components
import { Link, Text } from '@beef/ui-kit';
import { Icon, Status } from '../../../../components';

// Mocks
import mock from './mock';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const SuccessPopupStatus = () => {
  let tariffCatalogLink = '#';
  if (typeof window !== 'undefined') {
    tariffCatalogLink = `${window.location.origin}${mock.success.changeTariffLink}`;
  }

  return (
    <>
      <div className={cn('description')}>
        <Text size="size5-r-s" color="grey50">{mock.success.description}</Text>
      </div>
      <Status>
        <div className={cn('status')}>
          <div className={cn('status__icon')}>
            <Icon name="info" className={cn('icon')} />
          </div>
          <div className={cn('status__text')}>
            <Text size="size6-m">
              {mock.success.informationText}
            </Text>
            <Link
              href={tariffCatalogLink}
              isNoUnderline
              size="size6-m"
            >
              {mock.success.changeTariffText}
            </Link>
          </div>
        </div>
      </Status>
    </>
  );
};

export { SuccessPopupStatus };
